import { z } from 'zod/v4'

/**
 * Validator for a single uploaded R2 multipart part.
 * Returned from R2 `uploadPart`.
 */
export const R2UploadedPartValidator = z.object({
	partNumber: z.number().int().positive(),
	etag: z.string(),
})

export type R2UploadedPart = z.infer<typeof R2UploadedPartValidator>
